import { API_STATES } from 'utils/redux'
import {
  fetchCourseSettingsRoutine,
  fetchSaltyBucksSettingsRoutine
} from './actions'
import { Action, SettingsReducer } from 'types'

export const initialState: SettingsReducer = {
  state: API_STATES.PRISTINE,
  courses: [],
  saltyBucks: []
}

export default (state = initialState, action: Action): SettingsReducer => {
  switch (action.type) {
    case fetchCourseSettingsRoutine.REQUEST:
      return {
        ...state,
        state: API_STATES.IN_PROGRESS
      }
    case fetchCourseSettingsRoutine.SUCCESS:
      return {
        ...state,
        state: API_STATES.DONE,
        courses: action.payload.data
      }
    case fetchCourseSettingsRoutine.FAILURE:
      return {
        ...state,
        state: API_STATES.DONE
      }
    case fetchSaltyBucksSettingsRoutine.REQUEST:
      return {
        ...state,
        state: API_STATES.IN_PROGRESS
      }
    case fetchSaltyBucksSettingsRoutine.SUCCESS:
      return {
        ...state,
        state: API_STATES.DONE,
        saltyBucks: action.payload.data
      }
    case fetchSaltyBucksSettingsRoutine.FAILURE:
      return {
        ...state,
        state: API_STATES.DONE
      }
    default:
      return state
  }
}
